<div *ngIf="socialData" style="background: #fff">
    <div
        [ngStyle.xs]="{
            padding: '0 0px 15px 17px'
        }"
        fxLayout="column"
        fxLayoutAlign.gt-xs="center center"
        fxLayoutAlign.xs="start"
        style="padding-bottom: 32px"
    >
        <div class="slider-title" [ngStyle.gt-xs]="{ marginBottom: '8px' }">
            <span [ngStyle.xs]="{ fontSize: '20px' }">{{
                socialData?.text
            }}</span>
        </div>
        <div class="slider-subtitle">
            <span [ngStyle.xs]="{ fontSize: '12px' }">{{
                socialData?.subtitle
            }}</span>
        </div>
    </div>
    <div
        class="slider"
        style="margin: 0 50px 0 50px"
        [ngStyle.xs]="{ margin: '0 17px 0 17px' }"
    >
        <div
            *ngFor="let data of socialData?.feed"
            class="slide-track"
            ngClass.xs="slide-track-mobile"
            fxLayout="row"
            fxFlex
            style="margin-right: 15px"
            [ngStyle.xs]="{ marginRight: '9px' }"
        >
            <div style="width: 353px" [ngStyle.xs]="{ width: '163px' }">
                <img style="width: 100%" src="{{ data?.image }}" appImageCDN />
            </div>
        </div>
    </div>
    <hr
        style="margin-top: 53px"
        [ngStyle.xs]="{ marginTop: '25px' }"
        fxShow="true"
    />
</div>
